var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-72"},[_c(_vm.stepComponent,{tag:"component",attrs:{"model":_vm.model,"state":{
      passwordValidation: _vm.passwordValidation,
      ttl: _vm.ttl,
      disableBy: _vm.disableBy
    }},on:{"changeComponent":_vm.changeComponent,"setDisableBy":_vm.setDisableBy,"submitHandler":_vm.submitHandler,"setPassword":_vm.setPassword}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }